// extracted by mini-css-extract-plugin
export default {"archive_card":"archive_archive_card__rCB6i","fadeInUp":"archive_fadeInUp__Kr8lH"};